module.exports = __webpack_public_path__ + "static/media/loading_1.cad1233b.gif";